import { render, staticRenderFns } from "./ProductKardex.vue?vue&type=template&id=272ff742"
import script from "./ProductKardex.vue?vue&type=script&lang=js"
export * from "./ProductKardex.vue?vue&type=script&lang=js"
import style0 from "./ProductKardex.vue?vue&type=style&index=0&id=272ff742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports